import { render } from "./ImageGalleryLightbox.vue?vue&type=template&id=49078c3c&scoped=true"
import script from "./ImageGalleryLightbox.vue?vue&type=script&lang=js"
export * from "./ImageGalleryLightbox.vue?vue&type=script&lang=js"

import "./ImageGalleryLightbox.vue?vue&type=style&index=0&id=49078c3c&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49078c3c"]])

export default __exports__